<header class="site-header">
  <div class="header-inner">
    <a class="brand" href="/">
      <img class="brand-logo" src="/images/orderyaa-icon.png" alt="orderYaa - Shop to nearest store" />
    </a>

    <nav class="main-nav" [class.open]="isMenuOpen()">
      <ul>
        <li><a href="#" class="active" (click)="closeMenu()">Home</a></li>
        <li><a href="#about" (click)="closeMenu()">About</a></li>
        <li><a href="#customer" (click)="closeMenu()">Customer</a></li>
        <li><a href="#partners" (click)="closeMenu()">Partners</a></li>
        <li><a href="#rider" (click)="closeMenu()">Riders</a></li>
        <li><a href="#erp" (click)="closeMenu()">ERP</a></li>
        <li><a href="#features" (click)="closeMenu()">Features</a></li>
        <li><a href="#screens" (click)="closeMenu()">Screens</a></li>
      </ul>

      <a
        class="contact-us-btn contact-us-btn-mobile"
        href="https://calendly.com/tahir-aslam-techcolleagues/meeting-with-tahir-aslam-founder-tech-colleagues?month=2026-07"
        target="_blank"
        rel="noopener"
        (click)="closeMenu()"
        >Book a meeting</a
      >
    </nav>

    <div class="header-actions">
      <a
        class="contact-us-btn"
        href="https://calendly.com/tahir-aslam-techcolleagues/meeting-with-tahir-aslam-founder-tech-colleagues?month=2026-07"
        target="_blank"
        rel="noopener"
        >Book a meeting</a
      >

      <button
        type="button"
        class="menu-toggle"
        aria-label="Toggle menu"
        [attr.aria-expanded]="isMenuOpen()"
        (click)="toggleMenu()"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </div>
</header>
